import { Classes, SectionCard } from "@blueprintjs/core";
import { SpeculativeProject } from "in_queue/types/projectType";
import { ScenarioMetadata } from "in_queue/types/scenarioType";
import { useMemo } from "react";
import { ScenarioAssumptionsSection } from "../ScenarioAssumptions";
import css from "../ScenarioAssumptions.module.scss";
import { ProjectSizePreviewWrapper } from "./ProjectSizePreviewWrapper";

export const SpeculativeProjectsSection: React.FC<{
    scenario: ScenarioMetadata;
}> = ({ scenario }) => {
    const numSpeculativeProjects = scenario.projectAdditions.length;

    const projectAdditionCards = useMemo(() => {
        return [...scenario.projectAdditions]
            .sort((a, b) => a.projectName.localeCompare(b.projectName))
            .map((sp: SpeculativeProject) => {
                let reductionInfo = <>included</>;

                const assumptions = scenario.assumptions[sp.projectId];
                if (assumptions) {
                    const { eris: erisReduction, nris: nrisReduction } =
                        assumptions;

                    if (erisReduction !== 100 || nrisReduction !== 100) {
                        reductionInfo = (
                            <ProjectSizePreviewWrapper
                                erisReduction={erisReduction}
                                nrisReduction={nrisReduction}
                                project={sp}
                                percentageReduction={assumptions}
                            />
                        );
                    }
                }
                return (
                    <SectionCard
                        key={sp.projectId}
                        padded={false}
                        className={css["scenario-assumptions-card"]}
                    >
                        <strong>
                            {sp.projectName} ({sp.projectId})
                        </strong>{" "}
                        is {reductionInfo}
                    </SectionCard>
                );
            });
    }, [scenario.projectAdditions, scenario.assumptions]);

    if (numSpeculativeProjects === 0) {
        return (
            <ScenarioAssumptionsSection
                section="speculativeProjects"
                title={`Included Study Projects (${numSpeculativeProjects})`}
            >
                <SectionCard
                    padded={false}
                    className={`${css["scenario-assumptions-card"]} ${Classes.TEXT_MUTED}`}
                >
                    No study projects have been included in this scenario.
                </SectionCard>
            </ScenarioAssumptionsSection>
        );
    }

    return (
        <ScenarioAssumptionsSection
            section="speculativeProjects"
            title={`Included Study Projects (${numSpeculativeProjects})`}
        >
            <div>{projectAdditionCards}</div>
        </ScenarioAssumptionsSection>
    );
};
